import { Helmet } from 'react-helmet';

import { PageProps } from '@/types/PageProps';

import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';
import { useIntl } from 'react-intl';
import { Tabs } from 'antd';
import FinancialClashFlow from '@/components/Charts/FinancialClashFlow';
import FinancialCostFixed from '@/components/Charts/FinancialCostFixed';

const FinancialChartsPage = ({ route }: PageProps) => {
  const intl = useIntl();

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <DefaultRouteTabs
        route={route.parent}
        basePath="/app/managementCharts"
        permissions={route.permissions}
      >
        <Tabs defaultActiveKey="cashFlow">
          <Tabs.TabPane tab="Fluxo de caixa" key="cashFlow">
            <FinancialClashFlow />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Custo (Fixo x Variável)" key="costFixed">
            <FinancialCostFixed />
          </Tabs.TabPane>
        </Tabs>
      </DefaultRouteTabs>
    </>
  );
};

export default FinancialChartsPage;
